import { AUTH_SIGN_IN_MODE_KEY, AUTH_SIGN_IN_MODE_VALUE } from '@/lib/auth'

export async function startDevLogin(returnPath = '/projects'): Promise<boolean> {
  if (typeof window === 'undefined') return false

  try {
    const response = await fetch('/api/dev-login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ returnPath }),
    })

    if (response.status === 404) return false
    if (!response.ok) {
      console.warn('[dev-login] Local login shortcut failed:', response.status)
      return false
    }

    const data = (await response.json()) as { actionLink?: unknown }
    if (typeof data.actionLink !== 'string' || data.actionLink.length === 0) return false

    localStorage.setItem('authReturnPath', returnPath)
    localStorage.setItem(AUTH_SIGN_IN_MODE_KEY, AUTH_SIGN_IN_MODE_VALUE)
    window.location.assign(data.actionLink)
    return true
  } catch (error) {
    console.warn('[dev-login] Local login shortcut failed:', error)
    return false
  }
}
